import { useState, useEffect, useCallback } from 'react';

type CallbackFunction = (...args: any[]) => void;

const useDebounce = (callback: CallbackFunction, delay = 1000) => {
  const [isWaiting, setIsWaiting] = useState(false);

  useEffect(() => {
    if (isWaiting) {
      const handler = setTimeout(() => {
        setIsWaiting(false);
        callback();
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [isWaiting, callback, delay]);

  const debouncedFunction = useCallback(() => {
    if (!isWaiting) {
      setIsWaiting(true);
    }
  }, [isWaiting]);

  const cancel = useCallback(() => {
    setIsWaiting(false);
  }, []);

  return { isWaiting, debouncedFunction, cancel };
};

export default useDebounce;
